import { memo } from 'react';
import { useSize } from 'ahooks';
import { Row, Table } from 'antd';

import { MilesText } from 'components';

import { IMilesTableProps } from 'types';

import { getColumnByType } from './lib';

const MilesTable = <T extends Record<string, unknown>, >({
  id, // is required if verticalScroll or horizontalScroll provided
  size,
  title,
  scroll,
  rowKey = 'id',
  loading,
  columns,
  expandable,
  components,
  pagination = false,
  dataSource,
  rowClassName,
  rowSelection,
  underTableNode,
  titleExtraNode,
  sortDirections,
  verticalScroll,
  horizontalScroll,
  onRow,
  onChange,
}: IMilesTableProps<T>) => {
  const divSize = useSize(document.getElementById(`${id}-id`));

  const isDataLessThanMinSize = (pagination && Number(pagination.total) < 10);

  const defaultIndent = (size === 'small' ? 105 : 120);

  const tablePagination = pagination && {
    ...pagination,
    showSizeChanger: true,
    hideOnSinglePage: isDataLessThanMinSize,
  };

  const tableScroll = {
    ...scroll,
    ...((id && divSize && horizontalScroll) && {
      x: divSize.width - 1,
    }),
    ...((id && divSize && verticalScroll) && {
      y: divSize.height - (isDataLessThanMinSize ? 75 : defaultIndent), // 75/105/120 - indents and pagination divSize
    }),
  };

  return (
    <>
      {(title || titleExtraNode) && (
        <Row
          align='middle'
          justify='space-between'
          className='mb-3'
        >
          <MilesText
            size='lg'
            className='font-semibold'
          >
            {title}
          </MilesText>

          {titleExtraNode}
        </Row>
      )}

      <div
        id={id ? `${id}-id` : ''}
        className='flex flex-1 flex-col'
      >
        <Table
          bordered
          size={size}
          rowKey={rowKey}
          scroll={tableScroll}
          columns={getColumnByType(columns)}
          loading={loading}
          expandable={expandable}
          pagination={tablePagination}
          components={components}
          dataSource={dataSource}
          rowSelection={rowSelection}
          rowClassName={rowClassName}
          sortDirections={sortDirections}
          onRow={onRow}
          onChange={onChange}
        />

        {underTableNode && (
          <div>{underTableNode}</div>
        )}
      </div>
    </>
  );
};

export default memo(MilesTable);
